var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('a-tooltip',{attrs:{"placement":"bottom"}},[_c('template',{slot:"title"},[_vm._v(" "+_vm._s(_vm.isFullscreen ? '退出全屏' : '切为全屏')+" ")]),_c('img',{staticStyle:{"height":"28px","cursor":"pointer"},attrs:{"src":require("@/assets/topBtn/1.png")},on:{"click":_vm.click}})],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }